import styled, { css } from 'styled-components'
import theme from 'styled-theming'

import { media } from '../../styles'

const VARIANTS = {
  itemWidth: {
    default: theme('variant', {
      'product-card': '15.2rem',
      'recipe-card': '15.2rem',
      'shelf-tile': '15.2rem',
      'shelf-tile-double': '100%',
      'help-tile': '15.2rem',
      'voucher-tile-profile': '100%',
      'voucher-tile-checkout': '100%',
      'editorial-banner': '100%',
      'recipe-cover': '24rem',
      'list-cover': '28rem',
      'cookbook-tab': '10.2rem',
      'cookbook-ingredient-card': '8rem',
    }),
    medium: theme('variant', {
      'product-card': '19.2rem',
      'recipe-card': '19.6rem',
      'shelf-tile': '13.6rem',
      'shelf-tile-double': '32rem',
      'help-tile': '19.2rem',
      'voucher-tile-profile': '46rem',
      'voucher-tile-checkout': '100%',
      'editorial-banner': '32rem',
      'recipe-cover': '32rem',
      'list-cover': '32rem',
      'cookbook-tab': '14.4rem',
      'cookbook-ingredient-card': '9rem',
    }),
  },

  centered: theme('centered', {
    [true]: 'center',
    [false]: 'start',
  }),
  gap: theme('gap', {
    12: '1.2rem',
    16: '1.6rem',
    24: '2.4rem',
  }),
}

const computeGridTemplateColumns = (autoFill, itemWidth) => {
  if (autoFill) {
    return css`
      grid-template-columns: repeat(auto-fill, minmax(${itemWidth}, 1fr));
    `
  }
  return css`
    grid-template-columns: repeat(auto-fill, ${itemWidth});
  `
}

const Styled = styled.div`
  display: grid;
  grid-gap: ${({ theme }) => (theme.gap ? VARIANTS.gap : '1.6rem')};
  ${({ autoFill }) =>
    computeGridTemplateColumns(autoFill, VARIANTS.itemWidth.default)};
  align-items: stretch;
  justify-content: ${VARIANTS.centered};
  grid-auto-rows: 1fr;
  grid-auto-columns: ${VARIANTS.itemWidth.default};
  width: 100%;
  ${media.medium`
    ${({ autoFill }) =>
      computeGridTemplateColumns(autoFill, VARIANTS.itemWidth.medium)};
    grid-gap: ${({ theme }) => (theme.gap ? VARIANTS.gap : '2.4rem')};
    grid-auto-columns: ${VARIANTS.itemWidth.medium};
  `}
`

export default Styled
